import { useEffect, useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../../styles/ListView.module.css';

const MusicTab = ({ switchTab, tabID, topics }) => {
  if (topics) {
    return (
      <Container fluid className={styles.musTabHolder}>
        <Row style={{ padding: 0, margin: 0 }}>
          <Col lg={4} md={4} xs={4} className={styles.musicCol} onClick={() => switchTab('01f,01c,01d,01g,01h')}>
            <div className={tabID == '01f,01c,01d,01g,01h' ? styles.musTabActive : styles.musTab}>全部</div>
          </Col>
          <Col lg={4} md={4} xs={4} className={styles.musicCol} onClick={() => switchTab('01f')}>
            <div className={tabID == '01f' ? styles.musTabActive : styles.musTab}>{topics['01f'] ? topics['01f'] : '...'}</div>
          </Col>
          <Col lg={4} md={4} xs={4} className={styles.musicCol} onClick={() => switchTab('01c')}>
            <div className={tabID == '01c' ? styles.musTabActive : styles.musTab}>{topics['01c'] ? topics['01c'] : '...'}</div>
          </Col>
          <Col lg={4} md={4} xs={4} className={styles.musicCol} onClick={() => switchTab('01d')}>
            <div className={tabID == '01d' ? styles.musTabActive : styles.musTab}>{topics['01d'] ? topics['01d'] : '...'}</div>
          </Col>
          <Col lg={4} md={4} xs={4} className={styles.musicCol} onClick={() => switchTab('01g')}>
            <div className={tabID == '01g' ? styles.musTabActive : styles.musTab}>{topics['01g'] ? topics['01g'] : '...'}</div>
          </Col>
          <Col lg={4} md={4} xs={4} className={styles.musicCol} onClick={() => switchTab('01h')}>
            <div className={tabID == '01h' ? styles.musTabActive : styles.musTab}>{topics['01h'] ? topics['01h'] : '...'}</div>
          </Col>
        </Row>
      </Container>
    );
  }

  return <></>
}

export default MusicTab;